import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item", "searchBar", "icon", "list"]

  toggle() {
    const bar = this.searchBarTarget
    const isOpen = !bar.classList.contains("w-0")

    if (isOpen) {
      bar.classList.add("w-0", "opacity-0")
      bar.classList.remove("w-full", "opacity-100")
      this.iconTarget.classList.remove("rotate-90")
      this.inputTarget.value = ""
      this.filter()
    } else {
      bar.classList.remove("w-0", "opacity-0")
      bar.classList.add("w-full", "opacity-100")
      this.iconTarget.classList.add("rotate-90")
      setTimeout(() => this.inputTarget.focus(), 300)
    }
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()

    this.itemTargets.forEach((item, i) => {
      const text = item.dataset.searchText
      const match = !query || text.includes(query)

      if (match) {
        item.style.display = ""
        item.style.animation = `fadeSlideIn 0.25s ease forwards ${i * 0.04}s`
        item.style.opacity = "0"
      } else {
        item.style.display = "none"
        item.style.animation = ""
      }
    })
  }

  connect() {
    this.listTarget.style.minHeight = "100vh"

    if (!document.getElementById("search-filter-keyframes")) {
      const style = document.createElement("style")
      style.id = "search-filter-keyframes"
      style.textContent = `
        @keyframes fadeSlideIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `
      document.head.appendChild(style)
    }
  }
}
